import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/cliente';

/** Preferências do usuário no servidor (07 §1.2, §2.6): GET/PUT /usuarios/eu/preferencias/{chave}. */
export function usePreferencia<T>(chave: string, padrao: T) {
  const cliente = useQueryClient();
  const q = useQuery({
    queryKey: ['preferencia', chave],
    queryFn: async () => ((await api.get<T | null>(`/usuarios/eu/preferencias/${chave}`)) ?? padrao),
    staleTime: Infinity,
  });
  const m = useMutation({
    mutationFn: (valor: T) => api.put(`/usuarios/eu/preferencias/${chave}`, valor),
    onMutate: (valor) => cliente.setQueryData(['preferencia', chave], valor),
  });
  return [q.data ?? padrao, m.mutate] as const;
}

export function useFavoritos() {
  const [lista, gravar] = usePreferencia<string[]>('ui.favoritos', []);
  const alternar = (codigo: string) => gravar(lista.includes(codigo) ? lista.filter((c) => c !== codigo) : [...lista, codigo].slice(-40));
  return { favoritos: lista, alternar, eFavorito: (c: string) => lista.includes(c) };
}

let pendente: ReturnType<typeof setTimeout> | undefined;

/** Últimas 20 rotinas; grava no servidor com debounce de 5 s (07 §2.6). */
export function useRecentes() {
  const cliente = useQueryClient();
  const [lista] = usePreferencia<string[]>('ui.recentes', []);
  const registrar = (codigo: string) => {
    const atual = cliente.getQueryData<string[]>(['preferencia', 'ui.recentes']) ?? [];
    if (atual[0] === codigo) return;
    const nova = [codigo, ...atual.filter((c) => c !== codigo)].slice(0, 20);
    cliente.setQueryData(['preferencia', 'ui.recentes'], nova);
    clearTimeout(pendente);
    pendente = setTimeout(() => void api.put('/usuarios/eu/preferencias/ui.recentes', nova).catch(() => undefined), 5000);
  };
  return { recentes: lista, registrar };
}
